export default __webpack_public_path__ + "static/media/wolfScetch.7864f205.jpg";